import styled from 'styled-components';

export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 25px;
    padding-top: 15px;
    align-items: center;
    border-top: 1px solid #e5ebf0;
    justify-content: space-between;

    @media screen and (min-width: 1280px) {
        flex-direction: row;
    }
`;

export const ActionIcons = styled.div`
    .btn-action {
        font-size: 22px;
        padding: 10px;
    }
`;

export const MoreActionList = styled.ul`
    margin: 0;
    width: 185px;
    padding: 5px 0;
    color: #464a53;
    text-align: left;
    list-style: none;

    li {
        cursor: pointer;
        padding: 7px 15px;
        transition: all 0.2s;

        &:hover {
            color: #fff;
            background: var(--color-primary-500);
        }
    }

    .action-delete-site {
        color: var(--color-danger-500);
    }

    hr {
        border: 0;
        margin-bottom: 2px;
        border-top: 1px solid;
        border-color: #e5ebf0;
    }

    .icon {
        margin-right: 7px;
    }
`;

export const EmptyCard = styled.div`
    text-align: center;
    padding: 25px 0;

    svg {
        color: var(--color-text-300);
    }
    h5 {
        font-size: 20px;
        font-weight: 400;
        color: var(--color-text-700);
    }
`;
